import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

/* Fade + rise on scroll into view */
export function Reveal({ children, delay = 0, y = 32, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

/* Masked line-by-line reveal (for headings). lines = array of strings/nodes */
export function MaskLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12 }) {
  return (
    <span className={className} aria-label={lines.filter((l) => typeof l === "string").join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

/* Masked line reveal triggered on scroll into view */
export function MaskLinesInView({ lines, className = "", lineClassName = "", stagger = 0.1 }) {
  return (
    <motion.span
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-12% 0px" }}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
            transition={{ duration: 0.95, ease: EASE, delay: i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}

/* Infinite editorial marquee */
export function Marquee({ items, speed = 40, className = "", separator = "·" }) {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: speed, ease: "linear", repeat: Infinity }}
      >
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="px-8">{item}</span>
            <span className="opacity-40">{separator}</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}
